export const formValidation = (
  email,
  password,
  username,
  isHasUsernmae,
  mobile
) => {
  const errors = {};
  // Username validation
  if (isHasUsernmae) {
    if (!username.trim()) {
      errors.username = 'Name is required';
    } else if (username.length < 3) {
      errors.username = 'Name must be at least 3 characters long';
    } else if (username.length > 50) {
      errors.username = 'Name must be less than 50 characters long'; // Corrected message
    } else if (!/^[a-zA-Z\s]+$/.test(username)) {
      errors.username = 'Name can only contain letters';
    }

    // Mobile number validation (country code + number format)
    if (!mobile.trim()) {
      errors.mobile = 'Mobile number is required';
    } else if (mobile.includes(' ')) {
      errors.mobile = 'Mobile number must not contain spaces';
    } else if (!/^\+[1-9]{1}[0-9]{1,3}[0-9]{9,12}$/.test(mobile.trim())) {
      errors.mobile =
        'Mobile number must be in the format +[CountryCode][Number]';
    } else if (mobile.trim().length >= 50) {
      errors.mobile = 'Mobile No must be less than 50 characters long';
    }
  }
  //Email validayion
  if (!email.trim()) {
    errors.email = 'Email is required';
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    errors.email = 'Email is invalid';
  }

  // Password validation
  if (!password) {
    errors.password = 'Password is required';
  } else if (password.length < 8) {
    errors.password = 'Password must be at least 8 characters long';
  } else if (!/[A-Z]/.test(password)) {
    errors.password = 'Password must contain at least one uppercase letter';
  } else if (!/[a-z]/.test(password)) {
    errors.password = 'Password must contain at least one lowercase letter';
  } else if (!/[0-9]/.test(password)) {
    errors.password = 'Password must contain at least one number';
  } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.password = 'Password must contain at least one special character';
  } else if (password.length > 20) {
    errors.password = 'Password must be less than 20 characters long';
  }
  return errors;
};
